/* ================================================================
   content.ts — the site copy, for whichever market this build is for.

   Components import copy from here and never from a market directly.
   The text itself lives in src/config/regions/<code>/content.ts; this
   file only re-exports the selected pack (see ./region.ts), so a new
   market never means editing a component.
   ================================================================ */

import { CONTENT } from './region';

export type {
  CalcFieldType,
  CalcFormat,
  CalcField,
  CalcMetric,
  CalcRow,
  CalcTeam,
  CalcProfession,
  MarketNotice,
} from './contentTypes';

export const {
  SITE,
  CONTACT_INFO,
  SOCIAL_LINKS,
  NAV_ITEMS,
  HOME,
  ABOUT,
  PRICING,
  CASE_MANAGEMENT_PAGE,
  FEATURES_PAGE,
  WORKFLOW_FEATURES_PAGE,
  BLOGS_PAGE,
  BLOG_POST_PAGE,
  CONTACT,
  RESPONSIBLE_AI_GOVERNANCE,
  RESPONSIBLE_AI,
  DATA_PRIVACY,
  PRIVACY_POLICY,
  TERMS_AND_CONDITIONS,
  PRACTICE_AREAS,
  FOOTER,
  MARKET_NOTICE,
  CALC_MODULES,
  CALC_PLANS,
  CALC_SCENARIOS,
  CALC_ADOPTIONS,
  CALC_BUFFERS,
  CALCULATORS_HERO,
  CALCULATORS,
} = CONTENT;
